import { BOOKING_FEE_DISCLAIMER_FETCHED } from './booking-fee-disclaimer-actions';

export default function (state = [], action) {
  switch (action.type) {
    case BOOKING_FEE_DISCLAIMER_FETCHED:
      return action.results;
		default:
	}
  return state;
}
